/**
 * Notifications are enabled unless explicitly disabled in the build environment.
 * Set REACT_APP_ENABLE_NOTIFICATIONS=false to turn off notification polling,
 * toasts, sounds, and the notification bell.
 */
export const isNotificationsEnabled = (): boolean =>
  String(process.env.REACT_APP_ENABLE_NOTIFICATIONS || '').trim().toLowerCase() !== 'false';
